/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const previewGraphMutationApprovalBodyMutationAddNodesItemClientIdMax = 36;

export const previewGraphMutationApprovalBodyMutationAddNodesItemClientIdRegExp = new RegExp(
  '^[a-z0-9._:-]+$',
);
export const previewGraphMutationApprovalBodyMutationAddNodesItemContentTypeClientIdMax = 36;

export const previewGraphMutationApprovalBodyMutationAddNodesItemContentTypeClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const previewGraphMutationApprovalBodyMutationAddNodesItemTypeDescriptionMax = 2000;

export const previewGraphMutationApprovalBodyMutationEditNodesItemContentTypeClientIdMax = 36;

export const previewGraphMutationApprovalBodyMutationEditNodesItemContentTypeClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const previewGraphMutationApprovalBodyMutationEditNodesItemTypeDescriptionMax = 2000;

export const previewGraphMutationApprovalBodyMutationRootClientIdsItemMax = 36;

export const previewGraphMutationApprovalBodyMutationRootClientIdsItemRegExp = new RegExp(
  '^[a-z0-9._:-]+$',
);
export const previewGraphMutationApprovalBodyMutationSetEdgesItemFromClientIdMax = 36;

export const previewGraphMutationApprovalBodyMutationSetEdgesItemFromClientIdRegExp = new RegExp(
  '^[a-z0-9._:-]+$',
);
export const previewGraphMutationApprovalBodyMutationSetEdgesItemToClientIdMax = 36;

export const previewGraphMutationApprovalBodyMutationSetEdgesItemToClientIdRegExp = new RegExp(
  '^[a-z0-9._:-]+$',
);

export const PreviewGraphMutationApprovalBody = zod.object({
  mutation: zod.object({
    addNodes: zod
      .array(
        zod.object({
          clientId: zod
            .string()
            .min(1)
            .max(previewGraphMutationApprovalBodyMutationAddNodesItemClientIdMax)
            .regex(previewGraphMutationApprovalBodyMutationAddNodesItemClientIdRegExp)
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          contentTypeClientId: zod
            .string()
            .min(1)
            .max(previewGraphMutationApprovalBodyMutationAddNodesItemContentTypeClientIdMax)
            .regex(previewGraphMutationApprovalBodyMutationAddNodesItemContentTypeClientIdRegExp)
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
          occurredAt: zod.string().optional(),
          subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
          typeDescription: zod
            .string()
            .min(1)
            .max(previewGraphMutationApprovalBodyMutationAddNodesItemTypeDescriptionMax)
            .optional(),
          typeName: zod.string().min(1).optional(),
          value: zod
            .object({
              booleanValue: zod.boolean().nullish(),
              dateValue: zod.string().nullish(),
              datetimeValue: zod.string().nullish(),
              numericValue: zod.number().nullish(),
              stringValue: zod.string().nullish(),
            })
            .optional(),
          valueType: zod.enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME']).optional(),
          variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
        }),
      )
      .optional(),
    deleteLineageUuids: zod.array(zod.uuid().describe('UUID v4 identifier')).optional(),
    editNodes: zod
      .array(
        zod.object({
          contentTypeClientId: zod
            .string()
            .min(1)
            .max(previewGraphMutationApprovalBodyMutationEditNodesItemContentTypeClientIdMax)
            .regex(previewGraphMutationApprovalBodyMutationEditNodesItemContentTypeClientIdRegExp)
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
          contentUuid: zod.uuid().describe('UUID v4 identifier'),
          occurredAt: zod.string().optional(),
          subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
          typeDescription: zod
            .string()
            .min(1)
            .max(previewGraphMutationApprovalBodyMutationEditNodesItemTypeDescriptionMax)
            .optional(),
          typeName: zod.string().min(1).optional(),
          value: zod
            .object({
              booleanValue: zod.boolean().nullish(),
              dateValue: zod.string().nullish(),
              datetimeValue: zod.string().nullish(),
              numericValue: zod.number().nullish(),
              stringValue: zod.string().nullish(),
            })
            .optional(),
          variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
        }),
      )
      .optional(),
    ownership: zod.enum(['user_owned', 'agent_owned']),
    removeEdges: zod
      .array(
        zod.object({
          fromContentUuid: zod.uuid().describe('UUID v4 identifier'),
          toContentUuid: zod.uuid().describe('UUID v4 identifier'),
        }),
      )
      .optional(),
    rootClientIds: zod
      .array(
        zod
          .string()
          .min(1)
          .max(previewGraphMutationApprovalBodyMutationRootClientIdsItemMax)
          .regex(previewGraphMutationApprovalBodyMutationRootClientIdsItemRegExp)
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
      )
      .optional()
      .describe(
        'Added root INSTANCE client IDs only. TYPE nodes and contained child INSTANCE nodes are not roots.',
      ),
    rootContentUuids: zod.array(zod.uuid().describe('UUID v4 identifier')).optional(),
    setEdges: zod
      .array(
        zod.object({
          carbonCopy: zod.boolean().optional(),
          certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']).optional(),
          edgeDescription: zod.string().nullish(),
          edgeKey: zod.string().nullish(),
          edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
          fromClientId: zod
            .string()
            .min(1)
            .max(previewGraphMutationApprovalBodyMutationSetEdgesItemFromClientIdMax)
            .regex(previewGraphMutationApprovalBodyMutationSetEdgesItemFromClientIdRegExp)
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          fromContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
          maxCount: zod.int().nullish(),
          minCount: zod.int().nullish(),
          position: zod.int().nullish(),
          toClientId: zod
            .string()
            .min(1)
            .max(previewGraphMutationApprovalBodyMutationSetEdgesItemToClientIdMax)
            .regex(previewGraphMutationApprovalBodyMutationSetEdgesItemToClientIdRegExp)
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          toContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        }),
      )
      .optional(),
    source: zod
      .object({
        messageContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        reachThreadId: zod.uuid().optional().describe('UUID v4 identifier'),
      })
      .optional(),
    subjectUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  }),
});

export type PreviewGraphMutationApprovalBody = zod.input<typeof PreviewGraphMutationApprovalBody>;
export type PreviewGraphMutationApprovalBodyOutput = zod.output<
  typeof PreviewGraphMutationApprovalBody
>;
